import { jsx as _jsx } from "react/jsx-runtime";
import * as Styled from './skeleton-pill-shape.styles';
export const SkeletonPillShape = ({ className, height, width = '100%', ...props }) => (_jsx(Styled.SkeletonPillShape, { "$height": height, "$width": width, className: className, "data-xds": "SkeletonPillShape", ...props }));
SkeletonPillShape.displayName = 'SkeletonPillShape';
//# sourceMappingURL=skeleton-pill-shape.js.map